
import helper from '../helper';

const goTop = function() {
    let elements = document.querySelectorAll('.wp-block-hayyabuild-goup');
    elements && elements.forEach( el => {
        const link = el.querySelector('a')
        const css = window.getComputedStyle(link)
        const size = link.offsetHeight + parseInt(css.marginBottom)
        link.style.top = (size * -1)+'px'
        
        el.style.display = window.pageYOffset < helper.header.offsetHeight ? 'none' : 'block';
        window.addEventListener('scroll', () => {
            el.style.display = ( window.pageYOffset > helper.header.offsetHeight -1 && 'block' ) || 'none';
        });
    })
}

export default goTop;
